import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AlertWarning14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8.08542 1.38764C7.60556 0.547871 6.39468 0.54787 5.91482 1.38764L0.776406 10.3799C0.300223 11.2132 0.901932 12.25 1.86171 12.25H5.00012V10.75H2.29251L7.00012 2.5117L11.7077 10.75H9.00012V12.25H12.1385C13.0983 12.25 13.7 11.2132 13.2238 10.3799L8.08542 1.38764Z'
      fill='currentColor'
    />
    <path d='M7.75 5.5V9.5H6.25V5.5H7.75Z' fill='currentColor' />
    <path
      d='M7 12.5C7.55228 12.5 8 12.0523 8 11.5C8 10.9477 7.55228 10.5 7 10.5C6.44772 10.5 6 10.9477 6 11.5C6 12.0523 6.44772 12.5 7 12.5Z'
      fill='currentColor'
    />
  </Svg>
);

AlertWarning14.displayName = 'AlertWarning14';
export default AlertWarning14;
